import { render, staticRenderFns } from "./MmFileUpload.vue?vue&type=template&id=6056ff9c&scoped=true"
import script from "./MmFileUpload.vue?vue&type=script&lang=ts"
export * from "./MmFileUpload.vue?vue&type=script&lang=ts"
import style0 from "./MmFileUpload.vue?vue&type=style&index=0&id=6056ff9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056ff9c",
  null
  
)

export default component.exports